import { Confetti } from '@phosphor-icons/react';

/*
 * Bilan de fin de parcours, adressé à l'enfant.
 *
 * `recap` absent n'est PAS le cas d'échec : depuis que le bilan est produit
 * avant le figeage, un parcours conclu en porte toujours un — y compris quand
 * le modèle est indisponible, le repli déterministe prenant alors le relais.
 * La bannière ne subsiste que pour les parcours figés avant son existence.
 */
export function ParcoursRecap({ recap }: { recap: string | null }) {
  if (!recap) {
    return (
      <div className="self-center my-2 p-[12px_18px] rounded-card text-center font-bold bg-naia-green-bg text-naia-green-deep">
        Parcours terminé ! Bravo.
      </div>
    );
  }
  return (
    <div className="self-stretch my-2 p-[14px_16px] rounded-card bg-naia-green-bg border border-[color-mix(in_srgb,var(--naia-green)_35%,transparent)] flex flex-col gap-[7px]">
      <p className="flex items-center gap-[7px] m-0 text-[13px] font-bold tracking-[0.06em] uppercase text-naia-green-deep">
        <Confetti size={17} weight="fill" className="shrink-0" />
        Bilan de fin de parcours
      </p>
      <div className="text-[14.5px] leading-[1.55] text-foreground whitespace-pre-wrap">{recap}</div>
    </div>
  );
}
